module.exports = __webpack_public_path__ + "img/icon-subscription.b1a4aa9a.svg";